import Header from "../components/Header";
import ReservationsPage from "../components/ReservationsPage";
import Footer from "../components/Footer";

const Reservations = () => {
  return (
    <div>
      <Header />
      <ReservationsPage />
      <Footer />
    </div>
  );
};

export default Reservations;
